import type { VignetteDefinition } from "./types";

/**
 * Holiday vignette — Johnny notices the ornaments EnvironmentDecorator has
 * hung on the palm while Christmas's real-calendar window is active. No
 * dedicated "ChristmasReact" animation exists yet (see fishing.vignette.ts's
 * note on the same gap); "Wave" stands in as a cheerful reaction.
 */
export const christmasVignette: VignetteDefinition = {
  id: "christmas",
  name: "Christmas on the island",
  category: "holiday",
  weight: 1, // irrelevant — holiday vignettes bypass weighted selection (see SceneDirector)
  animationClip: "Wave",
  loopAnimation: true,
  durationMs: 5000,
  cameraFraming: {
    // Pulled back much further than a typical close vignette shot — the
    // palm's crown (where the ornaments hang) sits ~5.5 units above the
    // ground, so this needs enough distance/height to fit Johnny *and*
    // the decorated crown in frame together, not just his upper body.
    offset: { x: 6, y: 3, z: 9 },
    targetOffset: { x: 0, y: 3, z: 0 },
  },
  dateWindow: { startMonth: 12, startDay: 18, endMonth: 12, endDay: 26 },
  audioCues: [],
  onEnter: (ctx) => ctx.decorator.setHoliday("christmas"),
  onExit: (ctx) => ctx.decorator.setHoliday(null),
};
